import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const RIGHT_PANEL_WIDTH = gridSize * 49;

export const RIGHT_SIDE_PANEL_EXPERIENCE = {
	experience: 'jiraHomeRightSidePanel',
	experienceId: undefined,
	analyticsSource: 'jira-home',
};
export const JIRA_HOME_PAGE_RIGHT_SIDE_PANEL = 'JIRA_HOME_PAGE_RIGHT_SIDE_PANEL';
